import { inject, Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class BreakpointObserverService {
	private breakpointObserver = inject(BreakpointObserver);

	private DESKTOP = '(min-width: 1024px)';

	readonly isMobile = toSignal(
		this.breakpointObserver.observe([Breakpoints.Handset]).pipe(
			map((result) => result.matches),
			distinctUntilChanged()
		),
		{ initialValue: false }
	);

	readonly isTablet = toSignal(
		this.breakpointObserver.observe([Breakpoints.Tablet]).pipe(
			map((result) => result.matches),
			distinctUntilChanged()
		),
		{ initialValue: false }
	);

	readonly isDesktop = toSignal(
		this.breakpointObserver.observe([this.DESKTOP]).pipe(
			map((result) => result.matches),
			distinctUntilChanged()
		),
		{ initialValue: false }
	);
}
